import { ContentViewStyle } from '@levelapp/softfabric';
export default class UlListViewStyle extends ContentViewStyle {
    constructor() {
        super(...arguments);
        this.containerUL = {
            display: 'flex',
            flexDirection: 'column',
            marginLeft: 15,
            marginTop: 10,
        };
        this.container = {
            display: 'flex',
            flexDirection: 'column',
            marginTop: 15,
            marginBottom: 15,
        };
        this.description = {
            display: 'flex',
        };
        this.descriptionText = {
            fontSize: 17,
        };
        this.line = {
            display: 'flex',
            flexDirection: 'row',
        };
        this.bullet = {
            fontSize: 20,
            alignSelf: 'center'
        };
        this.text = {
            fontSize: 15,
            alignSelf: 'center',
            paddingLeft: 5,
        };
        this.header = {
            fontSize: 15,
            alignSelf: 'center',
            paddingLeft: 5,
            fontWeight: '700',
        };
    }
}
